module.exports = __webpack_public_path__ + "assets/text.69d51675.svg";